export default "__VITE_ASSET__wEo8oAMQ__"